import gCivilMdl from '@/models/General/GCivilStatus'
import Service from '@/services/api/service'

export default class extends Service {
  static model = gCivilMdl
}